import React from 'react';
import { Navigate } from 'react-router-dom';
import jwtUtils from '../utilities/jwtUtils'; // Asegúrate de tener esta utilidad para decodificar el token

const ProtectedRoute = ({ element }) => {
  const payload = jwtUtils.getValidRefreshTokenPayload();
  if (!payload) {
      return <Navigate to="/401" replace />;
  }

  return element;
};

export default ProtectedRoute;
